import * as THREE from "three";
import { useState } from "react";
import { Html } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import ApartmentViewModel from "../../viewModels/ApartmentViewModel"
import NameLabelComponent from "./NameLabelComponent";

interface ApartmentNameComponentProps {
    apartmentViewModel: ApartmentViewModel
}

const UNICODE_HOUSE_ICON = "\u{1F3E0}";

const ApartmentNameComponent = (props: ApartmentNameComponentProps) => {

    const {scene} = useThree();

    const {apartmentViewModel} = props;
    const {apartment } = apartmentViewModel; 

    const [isCollapsed, setIsCollapsed] = useState(false);
    
    const getText = () => {
        return isCollapsed
            ? UNICODE_HOUSE_ICON
            : UNICODE_HOUSE_ICON + apartment.name;
    }

    const position = apartmentViewModel.getBoundingBox(scene).getCenter(new THREE.Vector3);

    return (
        <>
            <NameLabelComponent
                key={apartment.globalId}
                text={getText()}
                position={position}
                borderRadius={0.1}
                color="darkslategray"
                textColor="white"
                fontSize={0.3}
                onDoubleClick={() => setIsCollapsed(!isCollapsed)}
                
            />
        </>
    );
}

export default ApartmentNameComponent;